import 'dayjs/locale/th'
import dayjs from 'dayjs'
import { timeFn } from './type'
import moment, { Moment } from 'moment'

export const times: timeFn = (nbChildren, fn) =>
  Array.from({ length: nbChildren }, (_, key) => fn(key))

export const timestampLocaleString = (date: string, locale = ''): string => {
  switch (locale) {
    case 'th':
      return dayjs(date).add(543, 'year').locale('th').format('DD MMMM YYYY, HH:mm')
    case 'en':
    default:
      return dayjs(date).format('DD MMMM YYYY, HH:mm')
  }
}

export const branchConfigTimeConverter = (time: number): Moment => {
  const duration = moment.duration(time, 'minutes')
  const openTime =
    duration.asMinutes() === 0 ? moment.utc(0) : moment.utc().startOf('day').add(duration)
  const formattedOpenTime = openTime.format('HH:mm')
  return moment(formattedOpenTime, 'HH:mm')
}
